export const ANSWER_LOGIN_ID = 'ANSWER_LOGIN_ID';
export const ANSWER_PUBNUB_ID = 'ANSWER_PUBNUB_ID';
export const ANSWER_POST_ID = 'ANSWER_POST_ID';

export default Object.freeze({
  ANSWER_LOGIN_ID,
  ANSWER_PUBNUB_ID,
  ANSWER_POST_ID,
});
